import {GET, POST} from "@/services/gateway";

const getReport = (data) => {
  const {module, eventType, status, ...rest} = data;

  const transformedData = {
    ...rest,
    modules: module,
    eventTypes: eventType,
    statuses: status,
  };

  return POST('report/summary', transformedData);
}

const getOtherEventsReport = (data) => {
  return POST('report/summary/other', data);
}

const listEventLogs = (data) => {
  const {module, eventType, status, ...rest} = data;

  const transformedData = {
    ...rest,
    modules: module,
    eventTypes: eventType,
    statuses: status,
  };

  return POST('report/events', transformedData);
}

const exportEventLogs = (data) => {
  const currentDate = new Date();

  return POST('report/export', {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  });
}

const getJobDetails = (id) => {
  return GET(`report/events/${id}`,)
}

export {
  getReport,
  getOtherEventsReport,
  listEventLogs,
  exportEventLogs,
  getJobDetails,
}
